import React from 'react';

import { GridList, GridListTile } from '@material-ui/core';
import styled, { css } from 'styled-components';

import VoucherCard from './VoucherCard';

export default function Vouchers({ data }) {
  const isPremium = false;

  return (
    <Container>
      <StyledGridList disabled={!isPremium} spacing={24} cols={3.5}>
        {data.map((voucherData) => (
          <StyledGridListTile>
            <VoucherCard
              id={voucherData.id}
              name={voucherData.name}
              src={voucherData.image}
              denominations={voucherData.denominations}
            />
          </StyledGridListTile>
        ))}

        {/* <StyledGridListTile>
        <VoucherCard src={FlipkartLogoSrc} money="150" cost="80" />
      </StyledGridListTile>
      <StyledGridListTile>
        <VoucherCard src={BookmyshowLogoSrc} money="150" cost="80" />
      </StyledGridListTile>
      <StyledGridListTile>
        <VoucherCard src={UberLogoSrc} money="150" cost="80" />
      </StyledGridListTile> */}
      </StyledGridList>
      {!isPremium && <OverlayText>Available in Premium Plan</OverlayText>}
    </Container>
  );
}

const Container = styled.div`
  position: relative;
`;

const OverlayText = styled.div`
  position: absolute;
  color: #008ef0;
  font-size: 1.3rem;
  font-weight: 500;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledGridList = styled(GridList)`
  flex-wrap: nowrap;
  // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
  transform: translateZ(0);
  margin: -12px 0 !important;
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      cursor: initial;
      opacity: 0.2;
      overflow: hidden;
    `};
`;

export const StyledGridListTile = styled(GridListTile)`
  height: 248px !important;
  .MuiGridListTile-tile {
    box-shadow: ${(props) => props.theme.shadows[1]};
  }
`;
